const rankings = [
  {
    rank: 1,
    title: '暗夜追踪 第二季',
    category: '悬疑犯罪剧',
    hot: '本周播放 582万次',
    trend: 'up',
    change: '↑ 3位',
  },
  {
    rank: 2,
    title: '欢乐喜剧人 新一季',
    category: '喜剧综艺',
    hot: '本周播放 496万次',
    trend: 'up',
    change: '↑ 5位',
  },
  {
    rank: 3,
    title: '仙道至尊',
    category: '热血国漫',
    hot: '本周播放 428万次',
    trend: 'down',
    change: '↓ 1位',
  },
  {
    rank: 4,
    title: '蓝色星球III',
    category: '自然纪录片',
    hot: '本周播放 367万次',
    trend: 'new',
    change: '新上榜',
  },
  {
    rank: 5,
    title: '经典港片合集',
    category: '怀旧电影',
    hot: '本周播放 312万次',
    trend: 'up',
    change: '↑ 2位',
  },
  {
    rank: 6,
    title: '斗破苍穹 年番',
    category: '玄幻国漫',
    hot: '本周播放 289万次',
    trend: 'down',
    change: '↓ 2位',
  },
  {
    rank: 7,
    title: '海贼王 和之国篇',
    category: '热血日漫',
    hot: '本周播放 254万次',
    trend: 'stable',
    change: '持平',
  },
];

const rankColors = ['text-primary-500', 'text-accent-500', 'text-secondary-500'];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            热播榜单
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            本周最受欢迎影视内容实时排行
          </p>
        </div>

        <div className="max-w-[720px] mx-auto">
          <div className="bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden">
            {rankings.map((item, i) => {
              const rankIdx = i < 3 ? i : -1;
              return (
                <div
                  key={i}
                  className={`flex items-center gap-4 px-5 py-4 ${
                    i < rankings.length - 1 ? 'border-b border-background-100' : ''
                  } hover:bg-background-50 transition-colors duration-200 cursor-pointer`}
                >
                  <div className="w-8 flex items-center justify-center shrink-0">
                    {rankIdx >= 0 ? (
                      <span className={`text-xl font-heading font-bold ${rankColors[rankIdx]}`}>
                        {item.rank}
                      </span>
                    ) : (
                      <span className="text-sm font-medium text-foreground-400">{item.rank}</span>
                    )}
                  </div>

                  <div className="flex-1 min-w-0">
                    <h3 className="text-sm font-medium text-foreground-900 truncate">{item.title}</h3>
                    <p className="text-xs text-foreground-500">{item.category}</p>
                  </div>

                  <div className="hidden sm:block text-xs text-foreground-500 whitespace-nowrap">
                    {item.hot}
                  </div>

                  <div className="flex items-center gap-1 shrink-0">
                    <span
                      className={`text-xs font-medium whitespace-nowrap ${
                        item.trend === 'up'
                          ? 'text-primary-500'
                          : item.trend === 'new'
                          ? 'text-accent-500'
                          : 'text-foreground-400'
                      }`}
                    >
                      {item.change}
                    </span>
                    {item.trend === 'up' && (
                      <i className="ri-arrow-up-s-line text-primary-500 text-sm"></i>
                    )}
                    {item.trend === 'down' && (
                      <i className="ri-arrow-down-s-line text-foreground-400 text-sm"></i>
                    )}
                    {item.trend === 'new' && (
                      <i className="ri-flashlight-line text-accent-500 text-sm"></i>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}